import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more.svg';
import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';
import { useTranslation } from "react-i18next";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { probeExecTypes } from "./PodProfileData";
import { serviceTypes } from "../service/PodServiceData";
import StepLine from "../../base/tamplate/StepLine";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import CustomText from "components/base/CustomText";


export interface ArgsType {
    targetId: string;
    podProfileName: string;
    podProfileDesc: string;
    deploymentYn: boolean;
    deploymentCount: number;
    labels: string;
    annotations: string;
    selector: string;
    templateLabels: string;
}

interface PodProfileUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

PodProfileUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function PodProfileUpdate(props:PodProfileUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
    
    
    const [podProfileName, setPodProfileName] = useState("");
    const [podProfileDesc, setPodProfileDesc] = useState("");
    const [deploymentYn, setDeploymentYn] = useState(false);
    const [deploymentCount, setDeploymentCount] = useState("0");
    const [labels, setLabels] = useState("");
    const [annotations, setAnnotations] = useState("");
    const [templateLabels, setTemplateLabels] = useState("");
    const [selector, setSelector] = useState("");
    const [podProfileNameWarnYn, setPodProfileNameWarnYn] = useState(false);
    

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkPodProfileData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(()=>{
        if(props.args) {
            setPodProfileName(props.args?.podProfileName);
            setPodProfileDesc(props.args?.podProfileDesc);
            setDeploymentYn(props.args?.deploymentYn);
            setDeploymentCount(props.args?.deploymentCount.toString());
            setLabels(props.args?.labels);
            setAnnotations(props.args?.annotations);
            setSelector(props.args?.selector);
            setTemplateLabels(props.args?.templateLabels);
        }
    }, [props.args]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdatePodProfile();
        }
    }, [executeUpdateYn]);

    function checkPodProfileData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        setPodProfileNameWarnYn(false);
        let message = "";
        let error = false;
        if(!podProfileName || (deploymentYn && !deploymentCount)) {
            message = t("MESSAGE_POD_PROFILE_INFO_ENTER_ERROR_MESSAGE");
            if(!podProfileName) {
                setPodProfileNameWarnYn(true);    
            }
            error = true;
        }
        if(error == true) {
            executeResult({}, false, message);
        }
        
        return !error;


    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeUpdatePodProfile() {
        const updatePackageData = {
            pod_profile : {
                pod_profile_name: podProfileName,
                pod_profile_description: podProfileDesc,
                deployment_yn: deploymentYn,
                deployment_pod_count: deploymentYn ? Number(deploymentCount) : 1,
                labels: labels,
                annotations: annotations,
                selector: selector,
                template_labels: templateLabels
            }
        }

        requests.put(PLATFORM_URL.POD_PROFILE + '/' + props.args?.targetId, updatePackageData)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_POD_PROFILE_UPDATE_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }
    return (
            <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={{...style.infoBoxContainer, marginTop: 20}}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("POD_UPDATE_YAML_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={podProfileName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setPodProfileName} 
                                warnYn={podProfileNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} 
                                height={100} 
                                value={podProfileDesc} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setPodProfileDesc} 
                                warnYn={false} 
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("Labels")}
                            </Text>
                            <CustomTextInput
                                key={10} 
                                width={570} height={36} 
                                value={labels} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setLabels} 
                                warnYn={false} 
                                placeHolderText={t("key=value,key=value,...")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("Annotations")}
                            </Text>
                            <CustomTextInput
                                key={11} 
                                width={570} height={36} 
                                value={annotations} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setAnnotations} 
                                warnYn={false} 
                                placeHolderText={t("key=value,key=value,...")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("DEPLOYMENT_CHECK_TEXT")}
                            </Text>
                            <CustomSquareCheckBox
                                size={20}
                                label={"Deployment"} 
                                id={"DeploymentCheckbox"} 
                                checked={deploymentYn}
                                disabled={false}
                                textStyle={{
                                    fontFamily: FONT.REGULAR,
                                    fontSize: "12px",
                                    color: "#333"
                                }}
                                setCheckBoxStatus={(e)=>{setDeploymentYn(!deploymentYn)}}
                            />

                        </View>
                        <Text style={{
                            marginTop: -30, marginLeft: 150, marginBottom: deploymentYn? 0 : 20,
                            fontFamily: FONT.REGULAR,
                            fontSize: 12,
                            color: "#3a8344",
                        }}>
                            {t("MESSAGE_DEPLOYMEMT_CHECK_MESSAGE")}
                        </Text>
                        {
                            deploymentYn ?
                            <View style={{...style.AddInfoBox, height: 80}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                    <Text style={style.AddInfoColumnText}>
                                        {t("DEPLOYMENT_COUNT_TEXT")}
                                        <Text style={style.requireText}>
                                            *
                                        </Text>
                                    </Text>
                                    <CustomTextInput
                                        key={21} 
                                        width={100} height={33} 
                                        value={deploymentCount} 
                                        type={"text"} 
                                        activeYn={true} 
                                        inputCb={setDeploymentCount} 
                                        warnYn={false} 
                                    />
                                </View>
                            </View>
                            :null
                            
                        }
                        {
                            deploymentYn ? 
                            <Fragment>
                                <View style={style.rowContainer}>
                                    <Text style={style.columnText}>
                                        {t("Selector")}
                                    </Text>
                                    <CustomTextInput
                                        key={1111} 
                                        width={570} height={36} 
                                        value={selector} 
                                        type={"text"} 
                                        activeYn={true} 
                                        inputCb={setSelector} 
                                        warnYn={false} 
                                        placeHolderText={t("key=value")}
                                    />
                                </View>
                                <View style={style.rowContainer}>
                                    <Text style={style.columnText}>
                                        {t("TemplateLabels")}
                                    </Text>
                                    <CustomTextInput
                                        key={1112} 
                                        width={570} height={36} 
                                        value={templateLabels} 
                                        type={"text"} 
                                        activeYn={true} 
                                        inputCb={setTemplateLabels} 
                                        warnYn={false} 
                                        placeHolderText={t("key=value,key=value,...")}
                                    />
                                </View>
                            </Fragment>
                            :null
                        }
                    </View>
                </View>
                : null
                }
        </View>
    );
}


const style = StyleSheet.create({
    topContainer: {
        
    },
    listMainContainer: {
        marginTop: 38,
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
        borderRadius: 10,
        borderColor: "#9ea0a5",
        borderWidth: 0.5,
        marginBottom: 20,
    },
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    AddInfoBox: {
        width: 580, height: 230,
        marginLeft: 150, marginTop: 20, marginBottom: 20,
        paddingLeft: 20, paddingTop: 20, paddingBottom: 20, paddingRight: 40,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
    },
    AddInfoColumnText: {
        width: 130,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    }
});